import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { QueryObserverOptions } from '@tanstack/react-query';
import { reservationDataQueryKeys } from '#/services/queryKeys';
import OgRentalsReservation from '@jucy-nakuru/common/services/JucyRentalsApi/RentalsReservation';
import { DeepRequired } from 'utility-types';
import { RentalSelfServiceApiClient } from '#/services/rentalSelfServiceApiClient';
import { useAuthenticatedSelfServiceApi } from './useAuthenticatedSelfServiceApi';

export type RentalsReservation = DeepRequired<OgRentalsReservation>;
export type UseGetReservationOptions = Omit<QueryObserverOptions<RentalsReservation, Response>, 'queryKey' | 'queryFn'>;
export type UseGetReservationResult = UseQueryResult<RentalsReservation, Response>;
export const useGetReservation = (reservationReference?: string, options?: UseGetReservationOptions): UseGetReservationResult => {
    const rentalApiClient = useAuthenticatedSelfServiceApi() as RentalSelfServiceApiClient;
    return useQuery<RentalsReservation, Response>({
        queryKey: reservationDataQueryKeys.data(reservationReference),
        queryFn: async () => (await rentalApiClient?.getReservation(reservationReference as string)) as RentalsReservation,
        ...options,
        refetchOnWindowFocus: options?.refetchOnWindowFocus === undefined ? false : options.refetchOnWindowFocus,
        retry: options?.retry === undefined ? 0 : options.retry,
        enabled: options?.enabled !== false && Boolean(reservationReference && rentalApiClient?.getReservation),
        staleTime: options?.staleTime === undefined ? 60 * 1000 : options.staleTime,
    });
};
